import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);
const CONSENT_KEY = "kb_age_consent_v1";

export function SiteProvider({ children }) {
  const [consented, setConsented] = useState(() => localStorage.getItem(CONSENT_KEY) === "yes");
  const [geo, setGeo] = useState(null);

  const loadGeo = useCallback(async (country) => {
    try {
      const { data } = await api.get("/geo", { params: country ? { country } : {} });
      setGeo(data);
      if (country) localStorage.setItem("kb_country", country);
    } catch {
      setGeo({ country_code: null, source: "none", notice: null });
    }
  }, []);

  useEffect(() => {
    loadGeo(localStorage.getItem("kb_country") || undefined);
  }, [loadGeo]);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "yes");
    setConsented(true);
  };

  return (
    <SiteContext.Provider value={{ consented, accept, geo, setCountry: loadGeo }}>{children}</SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
